module.exports = __webpack_public_path__ + "images/emoji/kissing_cat.17328d471483007dd505.png";